module.exports = __webpack_public_path__ + "static/Gibson-Light-webfont-f53087fc13bc9f445e31073ec46547a4.ttf";